import React, { useState, useEffect, useContext, useRef } from 'react';
import LayoutSelectButton from 'components/layout_and_quote_builder/LayoutSelectButton.jsx';
import LayoutCarousel from 'components/layout_and_quote_builder/LayoutCarousel.jsx';
import LayoutMostEfficient from 'components/layout_and_quote_builder/LayoutMostEfficient.jsx';
import LayoutNavSubSectionWrapped from 'components/layout_and_quote_builder/LayoutNavSubSectionWrapped.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import PostRequest from 'components/common/PostRequest.jsx';
import LayoutNavSectionCombinationListList from 'components/layout_and_quote_builder/LayoutNavSectionCombinationListList.jsx';

const LayoutNavSectionCombinationList = ({ navSection, index, count, setSelectedList, materialLayoutDimensions}) => {
  const [loading, setLoading] = useState(true)
  const [notFound, setNotFound] = useState(false)

  const [navSectionCombinations, setNavSectionCombinations] = useState( [ ] )

  const lastFetchTime = useRef(0);
  const fetchCombinations = () => {
    const now = Date.now();
    if (now - lastFetchTime.current < 100) {  return; }
    lastFetchTime.current = now;

    setLoading( () => true )

    PostRequest({
      url: `/layouts-nav-section-combinations/${window.drawingId}/${materialLayoutDimensions.layout_dimension_id}/${index}/${count}`,
      data: {
        formula_options: window.dielineOptions,
        material_layout_dimensions: materialLayoutDimensions,
      },
      callback: (data) => {
        setNavSectionCombinations( () => data.solutions )
        setLoading( () => false );
        setNotFound( () =>  data.solutions.length == 0 )
      }
    })
  }

   const sortingInProgress = useRef(false)
   const myRef = useRef();
   const sortDivs = () => {
    if (sortingInProgress.current) return;

    sortingInProgress.current = true;

    var $items = $(myRef.current).children("div");

    let isSorted = true;
    for (let i = 0; i < $items.length - 1; i++) {
        let num_i = parseInt($($items[ i ]).attr("data-score"));
        let num_i_plus_1 = parseInt ($($items[ i+1 ]).attr("data-score"));
        if (num_i > num_i_plus_1 ) {
            isSorted = false;
            break;
        }
    }

    if (!isSorted) {
      $items.sort((a, b) => parseInt ($(a).attr("data-score"))  -  parseInt( $(b).attr("data-score") ) );
      $(myRef.current).append($items);
    }

    sortingInProgress.current = false;
    setTimeout(sortDivs, 100);
  };

  const showNavSectionCombinationGroup = ( list ) => {
    return <LayoutNavSectionCombinationListList list={list} count={count} setSelectedList={setSelectedList} />
  }

  // const showNavSectionCombination = ( result ) => {
  //   return <LayoutNavSectionCombination
  //     diecutting_result={result.diecutting_result}
  //     count={result.count}
  //     layout_dimension={result.material_layout_dimension}
  //   />
  // }

  // useEffect starts
  useEffect(fetchCombinations, [ count, materialLayoutDimensions ])
  useEffect(sortDivs, [ ])

  // useEffect ends

  if(notFound) {
    return "cözüm bulunamadi..."
  }

  return (
    <div>
      {loading && <div> <img src="/bx_loader.gif" width="30px"/> </div> }

      {!loading && (
        <div ref={myRef} className={styles.combinations_grid}>
          {navSectionCombinations.map(showNavSectionCombinationGroup)}
        </div>
        )}

    </div>
  )
}

export default LayoutNavSectionCombinationList;
